export default __webpack_public_path__ + "static/media/57_desktop.febc8fa6.jpg";